import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d70cc6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "social-list padded-height" }
const _hoisted_2 = ["target", "href", "onMouseenter"]

import GlitchedText from "@/components/GlitchedText.vue";
import ContentPage from "../ContentPage.vue";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialView',
  setup(__props) {

const socialHover = ref(-1);
const socials = [
  {
    text: "github",
    href: "github.com/Timothyvanderveen",
  },
  {
    text: "linkedin",
    href: "linkedin.com/in/timothyvanderveen/",
  },
  {
    text: "instagram",
    href: "instagram.com/t.vdveen_/",
  },
];

return (_ctx: any,_cache: any) => {
  const _directive_glitched = _resolveDirective("glitched")!

  return (_openBlock(), _createBlock(ContentPage, {
    full: true,
    class: "content-page__social"
  }, {
    full: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socials, (social, index) => {
          return _createElementVNode("div", {
            key: index,
            class: "social"
          }, [
            _withDirectives(_createElementVNode("a", {
              target: social.href !== '' ? '_blank' : '',
              href: `//${social.href}`,
              class: "primary-font",
              onMouseenter: ($event: any) => (socialHover.value = index),
              onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (socialHover.value = -1))
            }, null, 40, _hoisted_2), [
              [_directive_glitched, socialHover.value === index ? `${social.text}>` : social.text]
            ])
          ])
        }), 64))
      ])
    ]),
    _: 1
  }))
}
}

})